import { COSMOS_DOMAIN, DOMAIN } from 'shared/helpers/globals';

export const LOGOUT_URL = `${DOMAIN}/logout`;
export const TERMS_OF_SERVICE_URL = `${DOMAIN}/terms`;
export const PRIVACY_POLICY_URL = `${DOMAIN}/privacy`;

export const getHowItWorksRedirectUrl = () => `${COSMOS_DOMAIN}/how-it-works-sell`;
